import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { Box } from "../../box/src";
import { ignoredProps } from "../../theme/src";
export const Badge = ({ bg, children, color, dataTestId, position, right, top, }) => (_jsx(Wrapper, { bg: bg, color: color, "data-testid": dataTestId, position: position, right: right, top: top, children: children }));
const Wrapper = styled(Box)
    .withConfig({
    shouldForwardProp: (prop) => !ignoredProps.includes(prop),
})
    .attrs(({ bg, color, position, right, top }) => ({
    alignItems: 'center',
    bg: bg !== null && bg !== void 0 ? bg : 'fire',
    color: color !== null && color !== void 0 ? color : 'white',
    font: 'footnote-asphalt',
    justifyContent: 'center',
    pb: '6px',
    position: position !== null && position !== void 0 ? position : 'absolute',
    pt: 1,
    px: 1,
    right: right !== null && right !== void 0 ? right : { l: '10px', s: 0 },
    top: top !== null && top !== void 0 ? top : '0px',
})) `
  border-radius: 50%;
  min-width: 16px;
  height: 16px;
`;
//# sourceMappingURL=Badge.js.map